import { render, staticRenderFns } from "./BaseInputText.vue?vue&type=template&id=f85a5942&scoped=true&"
import script from "./BaseInputText.vue?vue&type=script&lang=js&"
export * from "./BaseInputText.vue?vue&type=script&lang=js&"
import style0 from "./BaseInputText.vue?vue&type=style&index=0&id=f85a5942&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f85a5942",
  null
  
)

export default component.exports